module.exports = "/_next/static/resources/sourcing-4d0034ace5d1195a1c602231ba2f4912.png";